import useConfig from './useConfig';
export default function useConfigPodName() {
  const config = useConfig();
  const result = config == null ? void 0 : config.podName;
  if (typeof result !== 'string') {
    throw new Error('podName is not set');
  }
  return result;
}